import React from 'react';
import { useSelector } from 'react-redux';
import { newListingSelectors } from 'redux/new-listing.slice';
import { RootState } from 'redux/root-reducer';
import WsButton from 'stories/inputs/WsButton';
import WsFlexbox from 'stories/layout/WsFlexbox';

import { StepProps } from './CreateListing';
import ListingSummary from './ListingSummary';
import PreviewDialog from './PreviewDialog';
import StepperFooter from './StepperFooter';

const ListingReview = (props: StepProps) => {
  const year = useSelector((state: RootState) => newListingSelectors.year(state));
  const make = useSelector((state: RootState) => newListingSelectors.make(state));
  const model = useSelector((state: RootState) => newListingSelectors.model(state));
  const trim = useSelector((state: RootState) => newListingSelectors.trim(state));
  const trimId = useSelector((state: RootState) => newListingSelectors.trimId(state));

  const mileage = useSelector((state: RootState) => newListingSelectors.mileage(state));
  const price = useSelector((state: RootState) => newListingSelectors.price(state));
  const zipCode = useSelector((state: RootState) => newListingSelectors.zipCode(state));
  const city = useSelector((state: RootState) => newListingSelectors.city(state));
  const state = useSelector((state: RootState) => newListingSelectors.state(state));
  const email = useSelector((state: RootState) => newListingSelectors.email(state));
  const phone = useSelector((state: RootState) => newListingSelectors.phone(state));
  const conditionType = useSelector((state: RootState) => newListingSelectors.conditionType(state));
  const titleStatus = useSelector((state: RootState) => newListingSelectors.titleStatus(state));

  const bodyType = useSelector((state: RootState) => newListingSelectors.bodyType(state));
  const bodyTypeOther = useSelector((state: RootState) => newListingSelectors.bodyTypeOther(state));
  const colorType = useSelector((state: RootState) => newListingSelectors.colorType(state));
  const colorTypeOther = useSelector((state: RootState) => newListingSelectors.colorTypeOther(state));
  const cylinderType = useSelector((state: RootState) => newListingSelectors.cylinderType(state));
  const cylinderTypeOther = useSelector((state: RootState) => newListingSelectors.cylinderTypeOther(state));
  const doorType = useSelector((state: RootState) => newListingSelectors.doorType(state));
  const doorTypeOther = useSelector((state: RootState) => newListingSelectors.doorTypeOther(state));
  const drivetrainType = useSelector((state: RootState) => newListingSelectors.drivetrainType(state));
  const drivetrainTypeOther = useSelector((state: RootState) => newListingSelectors.drivetrainTypeOther(state));
  const fuelType = useSelector((state: RootState) => newListingSelectors.fuelType(state));
  const fuelTypeOther = useSelector((state: RootState) => newListingSelectors.fuelTypeOther(state));
  const transmissionType = useSelector((state: RootState) => newListingSelectors.transmissionType(state));
  const transmissionTypeOther = useSelector((state: RootState) => newListingSelectors.transmissionTypeOther(state));
  const showContactInfo = useSelector((state: RootState) => newListingSelectors.showContactInfo(state));
  const listing = useSelector((state: RootState) => newListingSelectors.listing(state));

  const description = '';
  const listingDate = '';
  const status = '';
  const statusDate = '';
  const userId = '';

  const images = useSelector((state: RootState) => newListingSelectors.images(state));
  const heading = useSelector((state: RootState) => newListingSelectors.heading(state));

  const [previewDialogOpen, previewDialogOpenTo] = React.useState(false);

  const handlePreview = () => {
    previewDialogOpenTo(true);
  };

  const closePreview = () => {
    previewDialogOpenTo(false);
  };

  return (
    <>
      <PreviewDialog open={previewDialogOpen} listing={listing} closeAction={closePreview} />
      <WsFlexbox centered>
        <WsButton color="secondary" label="View Listing Preview" onClick={handlePreview} />{' '}
      </WsFlexbox>
      <ListingSummary
        {...{
          year,
          make,
          model,
          trim,
          trimId,
          heading,
          mileage,
          price,
          city,
          state,
          zipCode,
          email,
          phone,
          conditionType,
          titleStatus,
          bodyType,
          bodyTypeOther,
          colorType,
          colorTypeOther,
          cylinderType,
          cylinderTypeOther,
          doorType,
          doorTypeOther,
          drivetrainType,
          drivetrainTypeOther,
          fuelType,
          fuelTypeOther,
          transmissionType,
          transmissionTypeOther,
          images,
          handleJump: props.handleJump,
          description,
          listingDate,
          status,
          statusDate,
          userId,
          showContactInfo,
        }}
      />
      <StepperFooter
        handleCancel={props.handleCancel}
        isFirst={props.isFirst}
        isLast={props.isLast}
        handleBack={props.handleBack}
        handleNext={props.handleNext}
      />
    </>
  );
};

export default ListingReview;
